import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { environment } from "../../../environments/environment";
import { MessageHandlerService } from "../../services/message-handler.service";
import { EventEmitter } from "@angular/core";
import { Alert, AlertData } from "../data/alert";

@Injectable()
export class AlertService extends AlertData {
  emitter: EventEmitter<any> = new EventEmitter();
  api: string;
  apiCampaign: string;
  header: any;

  constructor(
    private http: HttpClient,
    private messageHandler: MessageHandlerService
  ) {
    super();
    this.api = environment.apiUrl;
  }



  async createAlert(alert: Alert) {
    try {
      let response = await this.http
        .post(this.api + "alert", alert)
        .toPromise();
      return response;
    } catch (e) {
      this.messageHandler.error(e);
      throw new Error(e.error.message);
    }
  }


  async deleteAlert(id: string) {
    try {

      let response = await this.http
        .delete(this.api + "alert/"+id)
        .toPromise();
      return response;

    } catch (e) {
      this.messageHandler.error(e);
      throw new Error(e.error.message);
    }
  }

  async editAlert(alert: Alert, id: string) {
    try {
      let response = await this.http
        .put(this.api + "alert/"+id, alert)
        .toPromise();
      return response;
    } catch (e) {
      this.messageHandler.error(e);
      throw new Error(e.error.message);
    }
  }

  async getAlerts(pagination: any, filter: any, order: any) {
    try {
      let response = await this.http
        .post(this.api + "alerts", {pagination, filter, order})
        .toPromise();
      return response;
    } catch (e) {
      this.messageHandler.error(e);
      throw new Error(e.error.message);
    }
  }

  async getAlertId(id: string) {
    try {

      let response = await this.http
        .get(this.api + "alert/"+id)
        .toPromise();
      return response;

    } catch (e) {
      this.messageHandler.error(e);
      throw new Error(e.error.message);
    }
  }

}
